module.exports = __webpack_public_path__ + "media/images/new/mobile/icons/doctor_with_cash-d3ec8c02fbd07e681d75741214421bbb.png";